import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Size preset for the Spinner: `'sm'` | `'md'` | `'lg'`. */
export type SpinnerSize = 'sm' | 'md' | 'lg'

const sizeClasses: Record<SpinnerSize, string> = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
}

interface SpinnerProps {
  size?: SpinnerSize
  className?: string
}

/** Animated loading spinner (SVG). Accepts `size` and optional `className`. */
export function Spinner({ size = 'md', className }: SpinnerProps) {
  return (
    <svg
      className={twMerge(clsx('animate-spin text-current', sizeClasses[size], className))}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-label="Loading"
      role="status"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  )
}
